import { Fragment } from "react";

import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import SpecialOfferForm from "components/form/SpecialOfferForm";

import { SaveContextProvider } from "context/save";

import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Offerta speciale creata con successo",
        errorMsg: "Errore nella creazione dell'offerta speciale",
        navigateTo: { link: "/offerte-speciali" },
    });

    return (
        <GridRow justifyContent={"right"}>
            <GridItem className={"button-under-paper"}>
                <Button variant={"contained"} onClick={onButtonClick}>
                    Salva
                </Button>
            </GridItem>
        </GridRow>
    );
}

function NuovaOffertaSpeciale() {
    return (
        <Fragment>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Nuova Offerta Speciale</h1>
                </GridItem>
            </GridRow>

            <SaveContextProvider>
                <SpecialOfferForm />

                <ButtonSave />
            </SaveContextProvider>
        </Fragment>
    );
}

export default NuovaOffertaSpeciale;
